import { configureStore } from '@reduxjs/toolkit'
import mydataReducer from '../src/stored/mydata'

export default configureStore({
  reducer: {
    counter: mydataReducer
  }
})